import { NgModule, provideBrowserGlobalErrorListeners, LOCALE_ID, inject, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule, HammerModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing-module';
import { App } from './app';
import { CommonModule, registerLocaleData } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpHeaders, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { AuthModule } from './auth/auth.module';
import { HomeModule } from './home/home.module';
import { AuthorizationsModule } from './authorizations/authorizations.module';
import { LeafletModule } from '@bluehalo/ngx-leaflet';
import { provideApollo, provideNamedApollo } from 'apollo-angular';

import { GoogleAnalyticsService } from './../app/core';

import { getSpanishPaginatorIntl } from './core/models/common/spanish-paginator-intl';
import { SheetjsService } from './shared/services/sheetjs/sheetjs.service';
import { PickingProductivityModule } from './picking/picking-productivity/picking-productivity.module';
import { MsalApplicationModule } from './core/msal-application.module';
import localePy from '@angular/common/locales/es-PY';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import { MsalModule, MsalRedirectComponent } from '@azure/msal-angular';
import { InMemoryCache, ApolloLink } from '@apollo/client/core';
import { HttpLink } from 'apollo-angular/http';
import { SetContextLink } from '@apollo/client/link/context';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
registerLocaleData(localeEs);
registerLocaleData(localePy, 'es');
registerLocaleData(localeEn, 'en')

@NgModule({
  declarations: [
    App
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    SharedModule,
    HomeModule,
    AuthModule,
    AuthorizationsModule,
    AppRoutingModule,
    LeafletModule,
    MsalApplicationModule.forRoot(),
    MsalModule,
    HammerModule,
    PickingProductivityModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production
    }),
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    SheetjsService,
    { provide: LOCALE_ID, useValue: 'es' },
    GoogleAnalyticsService,
    { provide: MatPaginatorIntl, useValue: getSpanishPaginatorIntl() },
    provideBrowserGlobalErrorListeners(),

    provideApollo(() => {

      const httpLink = inject(HttpLink);

      const authLink = new SetContextLink((prevContext) => {

        const session = localStorage.getItem(environment.sessionAuth);
        const token = session ? JSON.parse(session)?.user?.access_token : null;

        let headers = prevContext.headers instanceof HttpHeaders
          ? prevContext.headers
          : new HttpHeaders(prevContext.headers);

        if (token) {
          headers = headers.set('Authorization', `Bearer ${token}`);
        }

        return { headers };

      });

      return {
        link: ApolloLink.from([
          authLink,
          httpLink.create({ uri: environment.apiEntity })
        ]),
        cache: new InMemoryCache()
      };

    }),

    provideNamedApollo(() => {

      const httpLink = inject(HttpLink);

      return {

        'user-report': {
          link: httpLink.create({
            uri: environment.apiUserReport
          }),
          cache: new InMemoryCache()
        },

        'dispatch-report': {
          link: httpLink.create({
            uri: environment.apiRunDispatchReport
          }),
          cache: new InMemoryCache()
        }

      };

    }),
    provideZoneChangeDetection(), 
    {
      provide: OVERLAY_DEFAULT_CONFIG,
      useValue: {
        usePopover: false  
      }
    }

  ],
  bootstrap: [App, MsalRedirectComponent]
})
export class AppModule { }
